import Cookies from 'js-cookie';
import { v4 } from 'uuid';

export default function GlobalContext() {
    const paths = Paths();
    const cookie = CookieMonster();

    return { paths: paths, cookie: cookie };
}

function CookieReset() {
    let cName = "bssantigua.com";
    Cookies.remove(cName);
}

function CookieMonster() {
    let cName = "bssantigua.com";
    let ucookie = Cookies.get(cName);
    if (ucookie) {
        return Cookies.getJSON(cName);
    }

    Cookies.set(cName, v4(), { expires: 730, path: '/' });
    return CookieMonster();
}

function Paths() {
    return {
        brochures: "/brochures/",
        pictures: "/images/",
        contact: "/contact/"
    }
}

export function Redirects() {

    return {
        homepage: "/1",
        request: "/request"
    }
}